import { CycleDetailPage } from '@/components/billing/cycle-detail-page'

export function AdminBillingCycleDetail() {
  return <CycleDetailPage basePath="/admin/billing" />
}
